import { render, staticRenderFns } from "./tenantAdministrator.vue?vue&type=template&id=7465707a&scoped=true"
import script from "./tenantAdministrator.vue?vue&type=script&lang=js"
export * from "./tenantAdministrator.vue?vue&type=script&lang=js"
import style0 from "./tenantAdministrator.vue?vue&type=style&index=0&id=7465707a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7465707a",
  null
  
)

export default component.exports